import React from "react"
import { ExpirationSettingsRule, IExpirationSingleSettings } from "../../generated"
import { FormTextInput } from "../../common/components/textInput"
import Button from "../../common/components/button"
import ProvinciaSelector from "../../comuni/components/ProvinciaSelector"
import { CheckBox } from "../../common/components/checkBox2"

interface Props {
    caption: string;
    settings: IExpirationSingleSettings;
    onChange: (settings: IExpirationSingleSettings) => void;
}

const RuleItem = ({ rule, setRule, onDelete }: { rule: ExpirationSettingsRule, setRule: (rule: ExpirationSettingsRule) => void, onDelete: () => void }) => {
    return <div className="d-flex flex-column">
        <Button
            onClick={onDelete}
            color="link"
            additionalClassName="text-danger align-self-end p-0"
            style={{ position: "absolute", right: 10, zIndex: 1 }}
        >
            <i className="fas fa-trash" /> Elimina
        </Button>
        <div className="d-flex justify-content-between align-items-center">
            <div className="mx-2">
                <div>

                    <ProvinciaSelector
                        value={rule.province ?? null}
                        onChange={province => setRule(new ExpirationSettingsRule({ beginAfterMonths: rule.beginAfterMonths, months: rule.months, province: province ?? undefined }))}
                    />
                </div>
            </div>
            <div className="mx-2">
                <FormTextInput
                    label="garanzia"
                    defaultValue={rule.beginAfterMonths}
                    onChange={e => {
                        const beginAfterMonths = +e.target.value;
                        if (!isNaN(beginAfterMonths))
                            setRule(new ExpirationSettingsRule({ ...rule, beginAfterMonths: beginAfterMonths > rule.months ? beginAfterMonths : rule.months }))
                    }}
                />
            </div>
            <div className="mx-2">
                <FormTextInput
                    label="mesi"
                    defaultValue={rule.months}
                    onChange={e => {
                        const months = +e.target.value;
                        if (!isNaN(months))
                            setRule(new ExpirationSettingsRule({ ...rule, months }))
                    }}
                />
            </div>
        </div>
    </div>
}

export default ({ caption, settings, onChange }: Props) => {
    const addRule = () => onChange({
        ...settings,
        rules: [...settings.rules, new ExpirationSettingsRule({ beginAfterMonths: 12, province: undefined, months: 12 })]
    });
    return <div>
        <div className="mb-3 d-flex align-items-center">
            <CheckBox
                checked={!settings.disabled}
                onChange={enabled => onChange({ ...settings, disabled: !enabled })}
            />
            <div className="fw-bold text-uppercase" >
                {caption}
                <div className="bg-theme w-100" style={{ height: 3, borderRadius: 30 }}></div>
            </div>
        </div>
        {!settings.disabled && <div className="d-flex flex-column">
            <ul className="list-group">
                {
                    settings.rules.map((rule, index) => <li key={index} className="list-group-item">
                        <RuleItem
                            rule={rule}
                            setRule={r => onChange({
                                ...settings,
                                rules: [...settings.rules.slice(0, index), r, ...settings.rules.slice(index + 1)],
                            })}
                            onDelete={() => onChange({
                                ...settings,
                                rules: [...settings.rules.slice(0, index), ...settings.rules.slice(index + 1)],
                            })}
                        />
                    </li>
                    )
                }
                <li className="list-group-item d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            {settings.rules.length > 0 ? "Tutte le altre province" : "Tutte le province"}
                        </div>
                        <div className="mx-2">
                            <FormTextInput
                                label="garanzia"
                                defaultValue={settings.beginAfterMonths}
                                onChange={e => {
                                    const beginAfterMonths = +e.target.value;
                                    if (!isNaN(beginAfterMonths))
                                        onChange({ ...settings, beginAfterMonths: beginAfterMonths > settings.defaultMonths ? beginAfterMonths : settings.defaultMonths })
                                }}
                            />
                        </div>
                        <div className="mx-2">
                            <FormTextInput
                                label="mesi"
                                defaultValue={settings.defaultMonths}
                                onChange={e => {
                                    const defaultMonths = +e.target.value;
                                    if (!isNaN(defaultMonths))
                                        onChange({ ...settings, defaultMonths })
                                }}
                            />
                        </div>
                    </div>
                </li>
            </ul>
            <div className="align-self-end">
                <Button onClick={addRule}><i className="fas fa-plus" /> Aggiungi regola</Button>
            </div>
        </div>}
    </div>
}